/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState } from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import "./Header.css";
import { isMobileOrTablet } from "../../components/Utils/index";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";
import { Link } from "react-router-dom";

const HeaderNavbar = ({isHomePage }) => {
  const [navbar, setNavbar] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();

  // Hardcoded header configuration
  const logo = {
    src: "https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png",
    alt: "SWMC logo",
    link: "https://www.swmc.com/"
  };

  const navItems = [
    {
      label: "Products",
      url: "/loan-programs",
      isExternal: false,
      isButton: false
    },
    {
      label: "Contact Us",
      url: "https://www.swmc.com/contact-us",
      isExternal: true,
      isButton: true
    }
  ];

  let prevScrollPos = window.scrollY;
  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");
    if (currentScrollPos === 0) {
      menuNavbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        // Perform your desired actions for scrolling up here
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        // Perform your desired actions for scrolling down here
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar.classList.add("navbarTransition");
        }
      }
    }
    prevScrollPos = currentScrollPos;
  };

  // Render navigation items based on hardcoded config
  const renderNavItems = () => {
    if (!navItems || !Array.isArray(navItems)) return null;

    return navItems.map((item, index) => {
      // Check if this item should be rendered as a button
      if (item.isButton) {
        // Render as a button
        return (
          <Button
            key={index}
            href={item.url}
            target={item.isExternal ? "_blank" : ""}
            rel={item.isExternal ? "noopener noreferrer" : ""}
            className="nav-button"
          >
            {item.label}
          </Button>
        );
      } else if (item.isExternal) {
        // Regular external link
        return (
          <Nav.Link
            key={index}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link-item"
          >
            {item.label}
          </Nav.Link>
        );
      } else {
        // Regular internal link
        return (
          <Nav.Link
            key={index}
            as={Link}
            to={`${process.env.REACT_APP_SWMC_CDN_URL}loan-programs/home`}
            target="_blank"  
            className="nav-link-item"
          >
            {item.label}
          </Nav.Link>
        );
      }
    });
  };

  return (
    <>
      <div>
        <Navbar
          id="menuNavbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? "navbar active" : "navbar"}
        >
          <Container className="navcont">
            <Navbar.Brand>
              <div className="nav-logo">
                <a
                  href={logo?.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={logo?.alt}
                >
                  <img
                    src={logo?.src}
                    className="main_logo"
                    alt={logo?.alt}
                  />
                </a>
              </div>
            </Navbar.Brand>

            <div className="header-right">
            {!isHomePage && navItems && (
                <Nav className="nav-links-container">
                  {renderNavItems()}
                </Nav>
              )}

              <UserWayAccessibilityMenu
                color="white"
                width={30}
                height={30}
              />
            </div>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default HeaderNavbar;